import { render, staticRenderFns } from "./Tipocliente.vue?vue&type=template&id=189ebe9d&"
import script from "./Tipocliente.vue?vue&type=script&lang=js&"
export * from "./Tipocliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports